module.exports = __webpack_public_path__ + "img/Image8.42b99ae8.png";